import { useParams, useNavigate } from 'react-router-dom';
import { TERMS_CONTENT } from './TermsContent';
import styles from './TermsViewer.module.css';

const TermsViewer = () => {
    const { type } = useParams<{ type: string }>();
    const navigate = useNavigate();

    const terms = type ? TERMS_CONTENT[type] : null;

    if (!terms) {
        return (
            <div className={styles.errorWrap}>
                <p>존재하지 않는 약관 페이지입니다.</p>
                <button onClick={() => navigate(-1)}>돌아가기</button>
            </div>
        );
    }

    const { title, Component } = terms;

    return (
        <div className={styles.pageWrap}>
            <div className={styles.card}>
                {/* 헤더 */}
                <div className={styles.header}>
                    <button
                        type="button"
                        className={styles.backBtn}
                        onClick={() => navigate(-1)}
                    >
                        <i className="ri-arrow-left-line" />
                    </button>
                    <h2 className={styles.title}>{title}</h2>
                </div>

                {/* 약관 본문 */}
                <div className={styles.body}>
                    <Component />
                </div>
            </div>
        </div>
    );
};

export default TermsViewer;
